module.exports = __webpack_public_path__ + "static/stretchconf2018-53c459487e872ebc82edf934c403e73f.webp";